
import { Sibling } from "@/types";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component
export default class PlatmapBreadcrumb extends Vue {
  private selectedNeighborhoodData = {} as Sibling;
  @Prop() communityUrl!: string;
  @Prop() communityName!: string;
  @Prop() isKioskMode!: boolean;
  @Prop() neighborhoods!: Sibling[];
  @Prop() selectedNeighborhoodIds!: string[];

  @Watch('selectedNeighborhoodIds') setNeighborhoodData(oldVal, newVal) {
    if (oldVal !== newVal) {
      this.setNeighborhoodInfo();
    }
  }
  mounted() {
    this.setNeighborhoodInfo();
  }

  setNeighborhoodInfo() {
    if(this.selectedNeighborhoodIds.length){
      const neighborhoodData = this.neighborhoods.find((neighborhood) => neighborhood.id === this.selectedNeighborhoodIds[0]);
      this.selectedNeighborhoodData = neighborhoodData ? neighborhoodData : {} as Sibling;
    } else {
      this.selectedNeighborhoodData = {} as Sibling;
    }
  }

  breadCrumbsNavigation(path) {
    window.open(path, "_blank");
  }
}
